import styled from 'styled-components';

export const ConteinerTab = styled.div`
  display: grid;

  > div:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const ConteinerTabInputs = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  input {
    text-align: right;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 51rem;


  @media (max-width: 768px) {
    width: 100%;
  }

  > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }

  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
    margin-top: 30px;
  }
`;

export const Wrapper = styled.div`
  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  // width: 80rem;
  width:100%;

  display: grid;

  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1rem;

  > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);

    // min-width: calc(100vw - 5.5rem);

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  }
`;

export const WrapperGroupFim = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 2rem;
  }

  p {
    display: ${(props) => (props.red ? 'block' : 'none')};
    font-weight: 700;
    color: red;
  }
`;

export const WrapperFim = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.5rem;
`;

export const WrapperIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 7.5rem;
    color: ${(props) => (props.red ? 'red' : 'green')};
  }
`;

export const WrapperInputs = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  input {
    text-align: right;
  }
`;
